module.exports = __webpack_public_path__ + "fontawesome-webfont.706450d7bba6374ca02f.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/fontawesome/fontawesome-webfont.ttf?v=4.3.0
// module id = ../../../../../src/assets/css/fonts/fontawesome/fontawesome-webfont.ttf?v=4.3.0
// module chunks = 2